var __rspack_ns_object = JSON.parse('{"Copied":"Test Copied","Failed to copy":"Test Failed to copy"}')